import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;

export default {
  async fetchCourses(query) {
    const url = `${URL}v1/cms/training-courses${query}`;
    return (await httpClient.get(url)).data;
  },
  async createCourse(course) {
    const url = `${URL}v1/cms/training-courses`;
    return await httpClient.post(url, course);
  },
  async updateCourse(course) {
    const url = `${URL}v1/cms/training-courses/${course.id}`;
    return await httpClient.put(url, course);
  },
  async removeCourse(courseId) {
    const url = `${URL}v1/cms/training-courses/${courseId}`;
    return await httpClient.delete(url);
  },
  async repeatCourse(courseId) {
    const url = `${URL}v1/cms/training-courses/copy/${courseId}`;
    return await httpClient.post(url);
  },
  async completeCourse(courseId, payload) {
    const url = `${URL}v1/cms/training-courses/${courseId}/complete`;
    return await httpClient.post(url, payload);
  },
  async finishCourse(courseId, payload) {
    const url = `${URL}v1/cms/training-courses/${courseId}/finish`;
    return await httpClient.post(url, payload);
  },
  async publishCourse({ courseId, payload, query }) {
    const url = `${URL}v1/cms/training-courses/${courseId}/publish${query}`;
    return await httpClient.post(url, payload);
  },
  async getCourseVolunteers(courseId, query) {
    const url = `${URL}v1/cms/training-courses/${courseId}/volunteers${query}`;
    return (await httpClient.get(url)).data;
  },
  async assignVolunteerToCourse(courseId, volunteerId) {
    const url = `${URL}v1/cms/training-courses/${courseId}/volunteers`;
    return await httpClient.post(url, { volunteerId });
  },
};